export default "__VITE_ASSET__BTNIQOvI__"